module.exports = __webpack_public_path__ + "img/sand.cf48aa13.svg";